import React, { forwardRef, useEffect, useRef, useState } from "react";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
} from "../StyledComp/StyledComp";
import { useDispatch } from "react-redux";
import {
  updateMember_Sections,
  updateMember_Tags,
} from "../../store/memberApiSlice";

import { useAppSelector } from "../../store/hooks";
import { isGeneratorFunction } from "util/types";

interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
  HasSectionOfficerResponsibility?: boolean;
}

interface IMemberShipOrders {
  Id: number | null;
  OrderId: number | null;
  MemberId: number | null;
  MemberCodeId: number | null;
  LastYearSections: string | null;
  CurrentYearSections: string | null;
  CurrentYearSectionsNotPaid: string | null;
  Description: string | null;
  Fee: number | null;
  MemberCode: string | null;
}

interface IAvailablePosition {
  Id: number;
  Name: string;
}

interface IAssignedPosition {
  Id: number; // assignment id (member_section_positions.Id)
  PositionId: number;
  PositionName: string;
}

interface IAvailableCommittee {
  Id: number;
  Name: string;
  Type: string; // "committee" | "subcommittee"
}

interface IAssignedCommittee {
  Id: number; // assignment id (member_committee_positions.Id)
  CommitteeId: number;
  CommitteeName: string;
  Role: string; // "Chair" | "Co-Chair"
}

interface IProps {
  section: ISection;
  membersActiveOrders: IMemberShipOrders[];
  lastYearSections: string; // string of comma separate number
  hasOfficerResponsibility?: boolean;
  onOfficerResponsibilityChange?: (sectionId: number, hasResponsibility: boolean) => void;
  memberSectionId?: number | null;
  availablePositions?: IAvailablePosition[];
  assignedPositions?: IAssignedPosition[];
  onAssignPosition?: (memberSectionId: number, positionId: number) => void;
  onRemovePosition?: (memberSectionId: number, assignmentId: number) => void;
  availableCommittees?: IAvailableCommittee[];
  assignedCommittees?: IAssignedCommittee[];
  onAssignCommittee?: (memberSectionId: number, committeeId: number, role: "Chair" | "Co-Chair") => void;
  onRemoveCommittee?: (memberSectionId: number, assignmentId: number) => void;
  // isSection: boolean;
}

const MDSectionsMultipleOptionItems: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const section = props.section;
  const currentMember = useAppSelector((state) => state.currentMember);
  // const [isSelected, setISSelected] = useState(props.section.Status);
  const [committeeToAdd, setCommitteeToAdd] = useState<string>("");
  const [roleToAdd, setRoleToAdd] = useState<"Chair" | "Co-Chair">("Chair");

  const [membersActiveOrders, setMembersActiveOrders] = useState<number[]>([]);
  const [lastYearSections, setLastYearSections] = useState<number[]>([]);
  const [
    membersCurrentYearNotPaidSections,
    setMembersCurrentYearNotPaidSections,
  ] = useState<number[]>([]);
  const [membersLastYearSections, setMembersLastYearSections] =
    useState<number[]>();

  console.log("membersActiveOrders:", props.membersActiveOrders);
  const handleChecked = (
    event: React.ChangeEvent<HTMLInputElement>,
    SectionName: string
  ) => {
    // setISSelected(!isSelected);
    section.isSelected = !section.isSelected;
  };

  const handleOfficerResponsibilityChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (props.onOfficerResponsibilityChange) {
      props.onOfficerResponsibilityChange(section.Id, event.target.checked);
    }
  };

    console.log("section:", section);

  useEffect(() => {
    // Recompute active/due/last-year arrays whenever props change
    if (
      props.membersActiveOrders &&
      props.membersActiveOrders[0] &&
      props.membersActiveOrders[0]!.CurrentYearSections !== null
    ) {
      setMembersActiveOrders(
        props.membersActiveOrders[0]!.CurrentYearSections!.split(",").map(
          Number
        )
      );
    } else {
      setMembersActiveOrders([]);
    }

    if (props.lastYearSections) {
      setLastYearSections(props.lastYearSections.split(",").map(Number));
    } else {
      setLastYearSections([]);
    }

    if (
      props.membersActiveOrders &&
      props.membersActiveOrders[0] &&
      props.membersActiveOrders[0]!.CurrentYearSectionsNotPaid !== null
    ) {
      setMembersCurrentYearNotPaidSections(
        props.membersActiveOrders[0]!.CurrentYearSectionsNotPaid!.split(
          ","
        ).map(Number)
      );
    } else {
      setMembersCurrentYearNotPaidSections([]);
    }

    // if (
    //   props.membersActiveOrders && props.membersActiveOrders[0] &&
    //   props.membersActiveOrders[0]!.LastYearSections !== null &&
    //   props.membersActiveOrders[0]!.LastYearSections !== undefined
    // ) {
    //   setMembersLastYearSections(
    //     props.membersActiveOrders[0]!.LastYearSections!.split(",").map(Number)
    //   );
    // }
    // const getOrderListsForMemberID = () => {
    //   membersActivememberShipOrderRef.current = [];
    //   console.log("membersActiveOrders", props.membersActiveOrders);
    //   props.membersActiveOrders.map((orderItem: any) => {
    //     membersActivememberShipOrderRef.current = [
    //       ...membersActivememberShipOrderRef.current,
    //       orderItem.MemberCodeId,
    //     ];
    //   });
    // };
    // getOrderListsForMemberID();
  }, []);

  const toCamelCase = (str: string) => {
    if (!str) {
      return ""; // or handle it based on your use case
    }

    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word: string, index: number) => {
        return index === 0 ? word.toUpperCase() : word.toLowerCase();
      })
      .replace(/\s+/g, "");
  };


  const isRelevantSection =
    (membersActiveOrders?.some(m => m === section.Id) || 
        membersCurrentYearNotPaidSections?.some(m => m === section.Id) ||
        lastYearSections?.some(m => m === section.Id));

  return (
    <>
      <div key={section.Id} className="checkboxgroup flex-col items-start">
        <div className="flex items-center">
            <input
              id={section.SectionName}
              className="checkbox"
              type="checkbox"
              checked={section.isSelected || membersActiveOrders.some(
            (MemberCode) => MemberCode === section.Id
          )}
              disabled={membersActiveOrders.some(
                (MemberCode) => MemberCode === section.Id
              )}
              onChange={(event) => handleChecked(event, section.SectionName)}
            />
            <span style={{ marginRight: "5px" }}>
              {Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(section.Fee as number)}
            </span>
            <div>{section.SectionName}</div>
            <span style={{ marginLeft: "5px" }}>
              {membersActiveOrders.some(
                (MemberCode) => MemberCode === section.Id
              ) ? (
                <span style={{ color: "#03c04A" }}> "(Active)" </span>
              ) : membersCurrentYearNotPaidSections &&
                membersCurrentYearNotPaidSections.some(
                  (MemberCode) => MemberCode === section.Id
                ) ? (
                <span style={{ color: "#df041a" }}>(Due)</span>
              ) : lastYearSections &&
                lastYearSections.some((MemberCode) => MemberCode === section.Id) ? (
                <span style={{ color: "rgb(45, 33, 213)" }}>(Last Year)</span>
              ) : (
                <></>
              )}
            </span>
        </div>
        <div>
            {isRelevantSection && (
              <>
                <div style={{ marginLeft: "15px", display: "flex", alignItems: "center" }}>
                  <input
                    id={`officer-responsibility-${section.Id}`}
                    className="checkbox"
                    type="checkbox"
                    checked={props.hasOfficerResponsibility || false}
                    onChange={handleOfficerResponsibilityChange}
                  />
                  <label
                    htmlFor={`officer-responsibility-${section.Id}`}
                    style={{ marginLeft: "8px", fontSize: "0.9rem" }}
                  >
                    Section Officer Responsibilities
                  </label>
                </div>

                {/* Section positions multi-select */}
                {props.memberSectionId != null && (
                  <div style={{ marginLeft: "15px", marginTop: "8px" }}>
                    <div style={{ fontSize: "0.9rem", marginBottom: "4px", fontWeight: 500 }}>
                      Section Positions
                    </div>

                    {/* Assigned positions as removable tags */}
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "6px" }}>
                      {(props.assignedPositions || []).map((assignment) => (
                        <span
                          key={assignment.Id}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            background: "#e3f0ff",
                            border: "1px solid #90c4f9",
                            borderRadius: "12px",
                            padding: "2px 8px",
                            fontSize: "0.82rem",
                            gap: "4px",
                          }}
                        >
                          {assignment.PositionName}
                          <button
                            type="button"
                            onClick={() =>
                              props.onRemovePosition &&
                              props.onRemovePosition(props.memberSectionId!, assignment.Id)
                            }
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              padding: "0 2px",
                              lineHeight: 1,
                              color: "#555",
                              fontSize: "0.85rem",
                            }}
                            title="Remove position"
                          >
                            ×
                          </button>
                        </span>
                      ))}
                    </div>

                    {/* Dropdown to add a position */}
                    {(() => {
                      const assignedIds = new Set((props.assignedPositions || []).map((a) => a.PositionId));
                      const unassigned = (props.availablePositions || []).filter((p) => !assignedIds.has(p.Id));
                      if (unassigned.length === 0) return null;
                      return (
                        <select
                          style={{
                            fontSize: "0.85rem",
                            padding: "3px 6px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                          value=""
                          onChange={(e) => {
                            const positionId = parseInt(e.target.value, 10);
                            if (positionId && props.onAssignPosition) {
                              props.onAssignPosition(props.memberSectionId!, positionId);
                            }
                          }}
                        >
                          <option value="">+ Add position…</option>
                          {unassigned.map((pos) => (
                            <option key={pos.Id} value={pos.Id}>
                              {pos.Name}
                            </option>
                          ))}
                        </select>
                      );
                    })()}
                  </div>
                )}

                {/* Section committees / subcommittees */}
                {props.memberSectionId != null && (
                  <div style={{ marginLeft: "15px", marginTop: "8px" }}>
                    <div style={{ fontSize: "0.9rem", marginBottom: "4px", fontWeight: 500 }}>
                      Section Committees
                    </div>

                    {/* Assigned committee/subcommittee chair roles as removable tags */}
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "6px" }}>
                      {(props.assignedCommittees || []).map((assignment) => (
                        <span
                          key={assignment.Id}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            background: "#e3f0ff",
                            border: "1px solid #90c4f9",
                            borderRadius: "12px",
                            padding: "2px 8px",
                            fontSize: "0.82rem",
                            gap: "4px",
                          }}
                        >
                          {assignment.CommitteeName} ({assignment.Role})
                          <button
                            type="button"
                            onClick={() =>
                              props.onRemoveCommittee &&
                              props.onRemoveCommittee(props.memberSectionId!, assignment.Id)
                            }
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              padding: "0 2px",
                              lineHeight: 1,
                              color: "#555",
                              fontSize: "0.85rem",
                            }}
                            title="Remove committee assignment"
                          >
                            ×
                          </button>
                        </span>
                      ))}
                    </div>

                    {/* Controls to add a committee/subcommittee chair role */}
                    {(() => {
                      const assignedIds = new Set((props.assignedCommittees || []).map((a) => a.CommitteeId));
                      const unassigned = (props.availableCommittees || []).filter((c) => !assignedIds.has(c.Id));
                      if (unassigned.length === 0) return null;
                      return (
                        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                          <select
                            style={{
                              fontSize: "0.85rem",
                              padding: "3px 6px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                              cursor: "pointer",
                            }}
                            value={committeeToAdd}
                            onChange={(e) => setCommitteeToAdd(e.target.value)}
                          >
                            <option value="">+ Add committee…</option>
                            {unassigned.map((committee) => (
                              <option key={committee.Id} value={committee.Id}>
                                {committee.Name} ({committee.Type === "subcommittee" ? "Subcommittee" : "Committee"})
                              </option>
                            ))}
                          </select>
                          <select
                            style={{
                              fontSize: "0.85rem",
                              padding: "3px 6px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                              cursor: "pointer",
                            }}
                            value={roleToAdd}
                            onChange={(e) => setRoleToAdd(e.target.value as "Chair" | "Co-Chair")}
                          >
                            <option value="Chair">Chair</option>
                            <option value="Co-Chair">Co-Chair</option>
                          </select>
                          <button
                            type="button"
                            disabled={!committeeToAdd}
                            onClick={() => {
                              const committeeId = parseInt(committeeToAdd, 10);
                              if (committeeId && props.onAssignCommittee) {
                                props.onAssignCommittee(props.memberSectionId!, committeeId, roleToAdd);
                                setCommitteeToAdd("");
                                setRoleToAdd("Chair");
                              }
                            }}
                            style={{
                              fontSize: "0.85rem",
                              padding: "3px 8px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                              cursor: committeeToAdd ? "pointer" : "not-allowed",
                              background: "white",
                            }}
                          >
                            Add
                          </button>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </>
            )}
        </div>
      </div>
    </>
  );
};

export default MDSectionsMultipleOptionItems;
